<app-display-information-page [title]="pageTitle" [content]="'Coming soon'" ></app-display-information-page>
